import React from "react";
import { Container, Box, Checkbox, Button, Divider } from "@mui/material";
import "./SuccessMockUpScreen.css";
import logo from "../assets/logo.png";
import emoji from "../assets/emoji.png";
import googleLogo from "../assets/google.ico";

const SuccessScreen = () => {
  return (
    <Container className="success-container">
      {/* Logo */}
      <div className="logo-container mt-3">
        <img src={logo} alt="Tipify Logo" className="logo2" />
      </div>
      {/* Mensaje principal */}
      <h4 className="main-text text-secondary">¡Propina en el Bote!</h4>

      {/* Emoji de celebración */}
      <Box className="emoji-container">
        <img src={emoji} alt="Celebration Emoji" className="emoji" />
      </Box>

      {/* Mensaje de agradecimiento */}
      <p className="thanks-text text-secondary mb-5">
        Gracias por dejar la propina. <br />
        Vuelve pronto.
      </p>

      {/* Checkbox para crear cuenta */}
      {/* <Box className="checkbox-container">
        <Checkbox />
        <p className="checkbox-text">
          Usa mis datos para <span className="highlight">crear una cuenta</span>{" "}
          en Tipify Technologies. <span className="link">Condiciones</span>
        </p>
      </Box> */}

      {/* Botón de compartir en Google */}
      <div className="d-flex flex-column text-center">
        <div className="mt-5">
          <Divider
            sx={{
              borderBottomWidth: 3,
              borderColor: "#66bc5f",
              width: "75%",
              opacity: 1,
              borderRadius: "10px",
              margin: "0 auto", // Centrar horizontalmente
              display: "block", // Asegurar que ocupe todo el ancho definido
            }}
          />
        </div>
        <span className="ask-text text-secondary">
          ¿Nos ayudas un poco más, compartiendo tu experiencia en Google?
        </span>
        <div className="mt-3">
          <Button
            style={{
              backgroundColor: "#f2f2f2",
              fontSize: "20px",
              color: "#888583",
              borderRadius: "30px",
              padding: "10px",
              width: "220px",
              height: "50px",
              textTransform: "none",
              border: "1px solid #888583",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", // Added box shadow
            }}
          >
            <div className="container">
              <img src={googleLogo} alt="Google" className="google-logo" />
              <span>¡Vamos!</span>
            </div>
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default SuccessScreen;
